module.exports = __webpack_public_path__ + "static/media/db07a153.jpg";